// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2020-11-03 00:25:34 +0100 (Tue, 03 Nov 2020) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 114601 $
//  Purpose   : timeline parts
// ---Third-party imports
import React from 'react'
import {Segment, Grid, Icon} from 'semantic-ui-react'

// ---Framework imports
import log from 'uix/logging'
import {Actions, Sel} from 'uix/registries'
import {keys} from 'ldash'
import {useSelector, useState, usePhysicalNode} from 'uix/hooks'

// ---Local imports
import {Timeline as XTimeline} from './components'

// ---Exports
export const Timeline = ({}) => {
  let node = usePhysicalNode()
  if (['metadata', 'topstructure'].includes(node.datatypeName)) {
    return <XTimeline otid={node.otid} />
  } else {
    return <XTimeline />
  }
}
